import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
export class SidenavStylingModel extends CoreStylingModel {
/**
 * StylingModel for content section
 */
content: StylingModel;
/**
 * StylingModel for leftSide section
 */
leftSide: StylingModel;
/**
 * StylingModel for rightSide section
 */
rightSide: StylingModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function SidenavStylingModel_tsickle_Closure_declarations() {
/**
 * StylingModel for content section
 * @type {?}
 */
SidenavStylingModel.prototype.content;
/**
 * StylingModel for leftSide section
 * @type {?}
 */
SidenavStylingModel.prototype.leftSide;
/**
 * StylingModel for rightSide section
 * @type {?}
 */
SidenavStylingModel.prototype.rightSide;
}

